module.exports = __webpack_public_path__ + "static/img/img-pak-suyadi.da70c0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-pak-suyadi.png
// module id = lcW6
// module chunks = 36